module.exports = __webpack_public_path__ + "static/media/ExerciseIconScience.b2e1f0b6.svg";